import {
  MULTI_SECTION_EVENT_LIST,
  CELL_EVENT_LIST,
} from '@/common/normalize/const'
import { mapEventList } from '@/common/converter/utils/map-event-list'

/**
 * 섹션(밴드 | 카탈로그) 레벨의 이벤트 리스트
 * ON_DISPLAY
 * ON_CONTENT
 * ON_VIEW_MORE
 * @param elementList
 * @returns {({cta: string, add_timestamp: string, method: string, add_common_params: string, bodylist: *, add_credential: string, type: string, url: *}|{}|{type: string, url: string, method: string, bodylist: [], add_common_params: string, add_timestamp: string, add_credential: string}|undefined)[]}
 */
export const convertMultiSectionEventList = (elementList = []) => {
  return MULTI_SECTION_EVENT_LIST.map((event) =>
    mapEventList(event, elementList),
  ).filter((event) => event)
}

/**
 * 셀(콘텍스트) 레벨의 이벤트 리스트
 * ON_NAVIGATION
 * ON_CLICK
 * ON_DETAIL
 * ON_INSTANT_PLAY
 * ON_ZZIM
 * OFF_ZZIM
 * @param elementList
 * @returns {({cta: string, add_timestamp: string, method: string, add_common_params: string, bodylist: *, add_credential: string, type: string, url: *}|{}|{type: string, url: string, method: string, bodylist: [], add_common_params: string, add_timestamp: string, add_credential: string}|undefined)[]}
 */
export const convertCellEventList = (elementList = []) => {
  return CELL_EVENT_LIST.map((event) =>
    mapEventList(event, elementList),
  ).filter((event) => event)
}
